import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import axios from 'axios';
import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';
const resources: any = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  }
};

// let currentLanguage = '';

const isApiDocumentation251Endpoint = (endpoint: string) =>
  endpoint.includes('/APIDocumentation25.1');

const fetchDrupalTranslations = async (lng: string) => {
  const env = process.env.REACT_APP_ENV_LOADED;
  const jsonEnvExt = env === 'PROD' ? '' : env === 'BAT' ? '-bat' : '-int';
  const jsonEnvUrl = `https://content-ndc-portal${jsonEnvExt}.aircanada.com/content`;

  const getStoredVersion = () => sessionStorage.getItem('version') || '';
  const getVersion = async () => await axios.get(`${jsonEnvUrl}/version.json`);

  try {
    const storedVersion = getStoredVersion();
    const versionResp = storedVersion
      ? { data: { version: storedVersion } }
      : await getVersion();
    const version =
      env === 'DEV' || env === 'INT' ? 'draft' : versionResp.data.version;

    const endpoints: string[] = [
      `${jsonEnvUrl}/${version}/AnnouncementBanner${
        i18n.language === 'fr' ? 'FR' : ''
      }.json`,
      `${jsonEnvUrl}/${version}/ReleaseNotes${
        i18n.language === 'fr' ? 'FR' : ''
      }.json`,
      `${jsonEnvUrl}/${version}/Roadmap${
        i18n.language === 'fr' ? 'FR' : ''
      }.json`,
      `${jsonEnvUrl}/${version}/KnownIssue${
        i18n.language === 'fr' ? 'FR' : ''
      }.json`,
      `${jsonEnvUrl}/${version}/GettingStarted${
        i18n.language === 'fr' ? 'FR' : ''
      }.json`,
      `${jsonEnvUrl}/${version}/HomeCaroussel${
        i18n.language === 'fr' ? 'FR' : ''
      }.json`,
      `${jsonEnvUrl}/${version}/POSMAP${
        i18n.language === 'fr' ? 'FR' : ''
      }.json`,
      `${jsonEnvUrl}/${version}/ApiSetup${
        i18n.language === 'fr' ? 'FR' : ''
      }.json`,
      `${jsonEnvUrl}/${version}/SellerSetup${
        i18n.language === 'fr' ? 'FR' : ''
      }.json`,
      `${jsonEnvUrl}/${version}/TestData${
        i18n.language === 'fr' ? 'FR' : ''
      }.json`,
      `${jsonEnvUrl}/${version}/APIOrchestration${
        i18n.language === 'fr' ? 'FR' : ''
      }.json`,
      `${jsonEnvUrl}/${version}/APIDocumentation${
        i18n.language === 'fr' ? 'FR' : ''
      }.json`,
      `${jsonEnvUrl}/${version}/APIDocumentation25.1${
        i18n.language === 'fr' ? 'FR' : ''
      }.json`,
      `${jsonEnvUrl}/${version}/FAQ${lng === 'fr' ? 'FR' : ''}.json`,
      `${jsonEnvUrl}/${version}/Benefits${lng === 'fr' ? 'FR' : ''}.json`,
      `${jsonEnvUrl}/${version}/News${lng === 'fr' ? 'FR' : ''}.json`,
      `${jsonEnvUrl}/${version}/Quotes${lng === 'fr' ? 'FR' : ''}.json`,
      `${jsonEnvUrl}/${version}/Scroller${lng === 'fr' ? 'FR' : ''}.json`,
      `${jsonEnvUrl}/${version}/Capabilitiestable${lng === 'fr' ? 'FR' : ''}.json`,
      `${jsonEnvUrl}/${version}/FunctionsAndFeaturesTable.json`,
      `${jsonEnvUrl}/${version}/ACConnex${lng === 'fr' ? 'FR' : ''}.json`,
      `${jsonEnvUrl}/${version}/RoadmapNew${lng === 'fr' ? 'FR' : ''}.json`,
      `${jsonEnvUrl}/${version}/Microsite${lng === 'fr' ? 'FR' : ''}.json`,

    ];

    const responses = await Promise.all(
      endpoints.map((endpoint) => axios.get(endpoint))
    );
    const mergedData = responses.reduce((acc, response, index) => {
      const data = response.data;
      const endpoint = endpoints[index];

      if (isApiDocumentation251Endpoint(endpoint)) {
        return {
          ...acc,
          api_documentation_25_1_api_document:
            data.api_documentation_api_document || [],
          api_documentation_25_1_tags: data.api_documentation_tags || []
        };
      }

      // Check if releasenotes_array exists
      if (data.release_notes_array && Array.isArray(data.release_notes_array)) {
        // Iterate over each item in releasenotes_array
        data.release_notes_array = data.release_notes_array.map((item) => {
          if (item.entries && Array.isArray(item.entries)) {
            // Update detailsRoute for each entry in entries array
            item.entries = item.entries.map((entry) => {
              let detailsRoute = entry.title;

              return {
                ...entry,
                detailsRoute // Update detailsRoute with the extracted content
              };
            });
          }

          return item;
        });
      }

      return { ...acc, ...data };
    }, {});
    return mergedData;
  } catch (error) {
    console.error('Error fetching Drupal translations:', error);
    throw error;
  }
};

export const initializeI18n = async () => {
  const urlPath = window.location.pathname;
  let detectedLanguage = 'en'; // Default to 'en'

  // Use switch case to detect language based on URL
  switch (true) {
    case urlPath.startsWith('/fr'):
      detectedLanguage = 'fr';
      break;
    case urlPath.startsWith('/en'):
      detectedLanguage = 'en';
      break;
    // Add more cases here for new languages
    default:
      detectedLanguage = 'en'; // Fallback to 'en'
  }

  await i18n.use(initReactI18next).init({
    resources,
    lng: detectedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

  const lng = i18n.language;

  try {
    const drupalTranslations = await fetchDrupalTranslations(lng);
    
    // Add resources individually to ensure they're all added
    Object.keys(drupalTranslations).forEach((key) => {
      i18n.addResource(lng, 'translation', key, drupalTranslations[key]);
    });

    i18n.emit('translationLoaded');
  } catch (error) {
    console.error('Error fetching Drupal translations:', error);
  }
};

// Commented below code to avoid double calls

// i18n.on('languageChanged', async (lng) => {
//   try {
//     if (currentLanguage === lng) {
//       return;
//     }
//     currentLanguage = lng;
//     const drupalTranslations = await fetchDrupalTranslations(lng);
//     i18n.addResources(lng, 'translation', drupalTranslations);
//   } catch (error) {
//     console.error('Error fetching Drupal translations:', error);
//   }
// });

export default i18n;
